import { render, staticRenderFns } from "./RuleParentSelector.vue?vue&type=template&id=51495bd2"
import script from "./RuleParentSelector.vue?vue&type=script&lang=js"
export * from "./RuleParentSelector.vue?vue&type=script&lang=js"
import style0 from "./RuleParentSelector.vue?vue&type=style&index=0&id=51495bd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports